<template>
  <path
    d="M3.00016 14C2.632 14 2.3335 13.7015 2.3335 13.3333V2.66667C2.3335 2.2985 2.632 2 3.00016 2C3.36833 2 3.66683 2.2985 3.66683 2.66667V13.3333C3.66683 13.7015 3.36833 14 3.00016 14Z"
    fill="url(#paint0_linear_11318_6608)" />
  <path
    d="M14 3.66668V11C14 11.1833 13.85 11.3333 13.6666 11.3333H7.66662C7.56662 11.3333 7.46995 11.2867 7.40662 11.2067C7.34332 11.13 7.31999 11.0267 7.33995 10.9267L9.00662 3.59334C9.04329 3.44001 9.17662 3.33334 9.33329 3.33334H13.6666C13.85 3.33334 14 3.48334 14 3.66668Z"
    fill="url(#paint1_linear_11318_6608)" />
  <path
    d="M9.7735 3.22L8.2935 9.74C8.26016 9.89333 8.12683 10 7.97016 10H4.66683C4.4835 10 4.3335 9.85 4.3335 9.66667V2.33333C4.3335 2.15 4.4835 2 4.66683 2H8.80016C9.1035 2 9.39016 2.13667 9.58016 2.37667C9.77016 2.61333 9.8435 2.92333 9.7735 3.22Z"
    fill="url(#paint2_linear_11318_6608)" />
  <defs>
    <linearGradient id="paint0_linear_11318_6608" x1="3.00016" y1="14" x2="3.00016" y2="2"
      gradientUnits="userSpaceOnUse">
      <stop stop-color="#1F7CF9" />
      <stop offset="0.9944" stop-color="#00B4FF" />
    </linearGradient>
    <linearGradient id="paint1_linear_11318_6608" x1="7.33295" y1="7.33334" x2="14" y2="7.33334"
      gradientUnits="userSpaceOnUse">
      <stop stop-color="#E24429" />
      <stop offset="1" stop-color="#FF872F" />
    </linearGradient>
    <linearGradient id="paint2_linear_11318_6608" x1="4.1275" y1="9.456" x2="8.61183" y2="2.38233"
      gradientUnits="userSpaceOnUse">
      <stop stop-color="#E24429" />
      <stop offset="1" stop-color="#FF872F" />
    </linearGradient>
  </defs>
</template>